import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { IndicatorsService } from './../../services/indicators/indicators.service';

@Component({
  selector: 'app-indicators-home',
  templateUrl: './indicators-home.component.html',
  styleUrls: ['./indicators-home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IndicatorsHomeComponent implements OnInit {


  carouselOptions: any = {
    loop: true,
    dots: false,
    navSpeed: 700,
    navText: ['<i class="flaticon-back"></i>', '<i class="flaticon-next"></i>'],
    items:3,
    nav: true,
    autoplay:true,
    responsive:{
      0:{
        items: 1
      },
      480 : {
        items: 1
      },
      768 :{
        items:3
      }
    }
  }

  indicators: any;

  constructor(
    private indicatorService: IndicatorsService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.getIndicators();
  }

  getIndicators() {
    this.indicatorService.getIndicators().subscribe((indicators) => {
      this.indicators = indicators;
      this.cdr.markForCheck();
    });
  }

  trackByIndex(_: number, item: any) {
    return (item && item.name) || _;
  }

}
